@if(item.navCap && hasPermission){
<div
  class="nav-caption-horizontal f-s-12 m-y-4"
  [class.text-muted]="!item.navCapEmphasis"
  [class.nav-caption--module]="item.navCapEmphasis"
>
  {{ item.navCap }}
</div>
}
@if(!item.navCap && hasPermission){
<a
  class="cursor-pointer menuLink {{ item.bgcolor }}"
  (click)="onItemSelected(item)"
  [ngClass]="{
    activeMenu: isItemActive(item)
  }"
>
  <i-tabler class="routeIcon icon-18" name="{{ item.iconName }}"></i-tabler>
  {{ item.displayName }}
  @if(item.children && item.children.length){
  <span class="down-icon d-flex m-l-auto">
    <mat-icon> expand_more </mat-icon>
  </span>
  }
</a>
} @if(item.children && hasPermission){
<div class="childBox">
  @for(child of item.children; track child){
  <app-horizontal-nav-item [item]="child" class="ddmenu">
  </app-horizontal-nav-item>
  }
</div>
}
